import React from 'react';
import ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import App from './app/App';
import { caisseTheme } from './app/theme';
import { missingCapabilities } from './app/capabilities';
import { API_BASE_URL, APP_VERSION, HEARTBEAT_INTERVAL_MS, UPDATE_CHECK_INTERVAL_MS } from './app/config';
import { createCaisseApi } from './api/caisseApi';
import { ensurePersistence, openCaisseStorage } from './store/storage';
import { registerServiceWorker } from './sw/register';

// Service worker en build seulement : en `vite dev`, il n'y a pas de sw.js.
// __CAISSE_REGISTER_SW__ vient de vite.config.mjs (vrai pour `vite build`).
let updateListener = null;
let updatePending = false;
// eslint-disable-next-line no-undef
const swController = __CAISSE_REGISTER_SW__
    ? registerServiceWorker({
        onUpdateReady: () => {
            updatePending = true;
            if (updateListener) updateListener();
        },
    })
    : null;

const services = {
    missingCapabilities: () => missingCapabilities(window),
    openStorage: (options) => openCaisseStorage(options),
    ensurePersistence: (options) => ensurePersistence(options),
    api: createCaisseApi({ baseUrl: API_BASE_URL }),
    serviceWorker: swController && {
        onUpdateReady(listener) {
            updateListener = listener;
            if (updatePending) listener();
        },
        checkForUpdate: () => swController.checkForUpdate(),
        applyUpdate: () => swController.applyUpdate(),
    },
    appVersion: APP_VERSION,
    heartbeatIntervalMs: HEARTBEAT_INTERVAL_MS,
    updateCheckIntervalMs: UPDATE_CHECK_INTERVAL_MS,
};

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <ThemeProvider theme={caisseTheme}>
            <CssBaseline />
            <App services={services} />
        </ThemeProvider>
    </React.StrictMode>
);
